import React from 'react';
import { Icon, Dialog, DialogActions, DialogTitle, DialogContent, IconButton, Typography, AppBar, Toolbar } from '@material-ui/core';
import { get } from 'global/lib/lodash';
import clsx from 'clsx';
import styles from './styles';
import { useScreen } from '../../styles';
import { Button } from '../Button';

export const FullScreen = (props) => {
  const classes = styles();

  const handleClose = () => {
    props.onClose();
  };

  return (
    <Dialog className={classes.dialog} fullScreen disableEscapeKeyDown open={props.open} onClose={() => handleClose()}>
      <DialogTitle classes={{ root: classes.dialogTitle }}>
        <AppBar color="secondary" className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
            <IconButton edge="start" color="inherit" onClick={() => handleClose()} aria-label="Close">
              <Icon>close</Icon>
            </IconButton>

            <div className={classes.barTitle}>
              <Typography variant="h5" className={classes.titleFull}>
                {props.title}
              </Typography>
            </div>

            {!!props.endIcon && <Icon style={{ marginLeft: 'auto' }}>{props.endIcon}</Icon>}
          </Toolbar>
        </AppBar>
      </DialogTitle>

      <DialogContent style={props.centerContentStyle} className={clsx(classes.contentWrap, props.centerContent)}>
        {props.children}
      </DialogContent>

      {!!props.buttons && (
        <DialogActions {...(props.dialogActions || {})}>
          {(props.buttons || []).map((btn, i) => {
            return (
              <Button key={i} color="secondary" {...btn}>
                {get(btn, 'title', 'Done')}
              </Button>
            );
          })}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default (props) => {
  const { isMobile } = useScreen();
  const classes = styles({ ...props, isMobile: isMobile });

  const Comp = props.content || props.children;

  return (
    <Dialog keepMounted={props.keepMounted} fullScreen={isMobile || props.fullScreen} className={classes.container} open={!!props.open} onClose={() => props.onClose()}>
      <DialogTitle className={classes.title}>{props.title}</DialogTitle>

      <DialogContent classes={{ root: classes.dialogContent }}>
        {Comp && !props.children && <div className={classes.content}>{typeof props.content === 'function' ? <Comp /> : props.content}</div>}

        {props.children && <div className={classes.content}>{props.children}</div>}
      </DialogContent>

      <IconButton onClick={() => props.onClose()} className={classes.close}>
        <Icon>close</Icon>
      </IconButton>

      <DialogActions {...(props.dialogActions || {})}>
        {(props.buttons || []).map((btn, i) => {
          return (
            <Button key={i} color="secondary" {...btn}>
              {get(btn, 'title', 'Done')}
            </Button>
          );
        })}
      </DialogActions>
    </Dialog>
  );
};
